import { jsx as _jsx } from "react/jsx-runtime";
// tslint:disable-next-line: import-name
import React from 'react';
import { useRecoilState } from 'recoil';
import { logger } from '@springtree/eva-sdk-core-logger';
import currentUserTokenState from './state/current-user/current-user-token-state.js';
import shoppingCartState from './state/checkout/shopping-cart-state.js';
import storage from './helpers/storage.js';
import userExpiration from './helpers/user-expiration.js';
import useSetServiceStale from './hooks/use-set-service-stale.js';
export default function EvaStateUserTokenMonitor() {
    const [userToken, setUserToken] = useRecoilState(currentUserTokenState);
    const refreshCart = useSetServiceStale({ serviceState: shoppingCartState });
    const userTokenExpiredHandler = React.useCallback((expiredToken) => {
        if (expiredToken === userToken) {
            logger.debug('[STATE:userTokenMonitor] User token expired', expiredToken)();
            // Clear the current user token atom
            // The atom effect will handle updating local storage
            //
            setUserToken('');
        }
    }, []);
    // Listen for user expirations so we can unset the user token and update the recoil data
    //
    React.useEffect(() => {
        userExpiration.subscribe(userTokenExpiredHandler);
        return () => userExpiration.unsubscribe(userTokenExpiredHandler);
    }, []);
    React.useEffect(() => {
        // Shopping cart state is special because an anonymous cart can be claimed
        // when a customer registers or logs in
        // When that occurs the anonymous (default keyed) request storage should
        // be removed to prevent a 403 when the user logs out.
        // Key structure for service builder state is: `${endpoint}:${userId}:${stateKey}`
        //
        const endpointUrl = storage.getItem('evaEndpointUrl');
        if (!endpointUrl) {
            return;
        }
        if (userToken) {
            logger.debug('[STATE:userTokenMonitor] Cleaning up any previous anonymous cart')();
            const shoppingCartStorageKey = `${endpointUrl.replace(/https?:\/\//, '')}:default:shoppingCartDetails`;
            storage.removeItem(shoppingCartStorageKey);
            const currentOrderStorageKey = `${endpointUrl.replace(/https?:\/\//, '')}:default:orderDetails`;
            storage.removeItem(currentOrderStorageKey);
        }
        // Always set the shopping cart as stale on token change
        //
        refreshCart();
    }, [userToken]);
    return (_jsx("div", {}));
}
//# sourceMappingURL=eva-state-user-token-monitor.js.map